export interface FluidSpecificationId {__fluidSpecificationId: number}

export default class FluidSpecification {
  id!: FluidSpecificationId; // TODO nullable?
  description = '';
  isSelected = false;

  static withDescription(description: string): FluidSpecification {
    const fs = new FluidSpecification();
    fs.description = description;
    fs.isSelected = true;
    return fs;
  }
}
